import { createType } from '../utils/helpers';

export const FUNDING_DOCUMENT_UPLOAD_FAILURE = createType(
  'DOCUMENTS',
  'FUNDING_DOCUMENT_UPLOAD_FAILURE',
);
export const FUNDING_DOCUMENT_UPLOAD_PROGRESS = createType(
  'DOCUMENTS',
  'FUNDING_DOCUMENT_UPLOAD_PROGRESS',
);
export const FUNDING_DOCUMENT_UPLOAD_START = createType(
  'DOCUMENTS',
  'FUNDING_DOCUMENT_UPLOAD_START',
);
export const FUNDING_DOCUMENT_UPLOAD_SUCCESS = createType(
  'DOCUMENTS',
  'FUNDING_DOCUMENT_UPLOAD_SUCCESS',
);
export const GET_DOCUMENT_LINK = createType('DOCUMENTS', 'GET_DOCUMENT_LINK');
export const REQUEST_FUNDING_SEARCH_DOCUMENT_LINK = createType(
  'DOCUMENTS',
  'REQUEST_FUNDING_DOCUMENT_LINK',
);
export const REQUEST_FUNDING_SEARCH_DOCUMENTS_LINK = createType(
  'DOCUMENTS',
  'REQUEST_FUNDING_SEARCH_DOCUMENTS_LINK',
);
export const REQUEST_REMOVE_FUNDING_DOCUMENT = createType(
  'DOCUMENTS',
  'REQUEST_REMOVE_FUNDING_DOCUMENT',
);
